import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EditCentroCustosComponent } from './edit-centro-custos.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { SharedModule } from 'src/app/shared/shared.module';
import { EditCentroCustosRoutingModule } from './edit-centro-custos.routing.module';

@NgModule({
  imports: [
    CommonModule, NgSelectModule, FormsModule, ReactiveFormsModule, EditCentroCustosRoutingModule, SharedModule
  ],
  declarations: [EditCentroCustosComponent]
})
export class EditCentroCustosModule { }
